import React from "react";
import LogoImg from '../../assets/logo.png';

const Logo=()=>{
    return(
        <img src={LogoImg} alt="logo" width={67} />
    )
}
export default Logo